/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  CalendarOutlined,
  EnvironmentOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  FilterOutlined,
  HomeOutlined,
  IdcardOutlined,
  MailOutlined,
  PhoneOutlined,
  SearchOutlined,
  SolutionOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Spin,
  Tag,
  Typography,
  Tabs,
  Collapse,
  InputNumber,
} from 'antd';
import { getFuentesDeReclutamiento } from 'api/catalogos/FuentesDeReclutamiento';
import { DATE_FRONTEND_FORMAT } from 'utils/normalizers';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  deleteCandidato, getCandidato, getCandidatos, getCandidatovistaOptimized, getEstadosCandidato, patchCandidato, postCandidato,
  putAutorizarContratacionDirecta,
} from 'api/catalogos/Candidatos';
import { checkToken } from 'api/utils';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { onError } from 'utils/handlers';
import { getEstadosCiviles, getGeneros } from 'api/usuarios';
import { getPaises } from 'api/catalogos/paises';
import { getCodigosPostales, getEstados, getMunicipio } from 'api/catalogos';
import { getTiposDeSeguridadSocial } from 'api/catalogos/tipoDeSeguridadSocial';
import { getNacionalidades } from 'api/catalogos/nacionalidades';
import { getTiposDeIdentificaciones } from 'api/catalogos/tiposDeIdentificaciones';
import {
  ESTADO_ACTIVO,
  ESTADO_BAJA,
  ESTADO_PRE_ALTA,
  ESTADO_REINGRESO,
  ESTADO_SUSPENDIDO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { getTiposDeSeguridadesSociales } from 'api/catalogos/tiposDeSeguridadesSociales';
import { getPreferenciaSPartidarias } from 'api/catalogos/PreferenciaPartidaria';
import Select from 'components/Select';
import {
  CURP_PATTERN, digitoVerificador, RFC_PATTERN, SLUG_PATTERN, NOMBRES_PATTERN_GENERICO,
} from 'utils/patterns';
import { getNivelesDeEstudios } from 'api/catalogos/nivelesDeEstudios';
import { getAbreviaturasDeCarreras } from 'api/catalogos/abreviaturasDeCarreras';
import { getComprobantesDeEstudios } from 'api/catalogos/comprobantesDeEstudios';
import { getEspecialidadesDeEstudios } from 'api/catalogos/especialidadesDeEstudios';
import { getEmpleado, getEmpleados, getEmpleadosConDatosOpFilteredPaginated } from 'api/estructuraOrganizacional/empleados';
import CustomSearch from 'components/customSearch';
import { getPuesto } from 'api/catalogos/puestos';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getPlaza } from 'api/catalogos/plazas';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import FichaCandidatos from './FichaCandidatos';
import CitasCalendario from '../Citas';
import CandidatoGeneral from '../CandidatoGeneral';
import CandidatoFiliacion from '../CandidatoFiliacion';
import CandidatoContacto from '../CandidatoContacto';
import DocumentosCandidato from './DocumentosCanditato';
import CandidatosEstudios from './CandidatosEstudios';
import DireccionesCandidato from './DireccionCandidatos';

const { Title, Text } = Typography;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const badgeColor = {
  'Cita para Entrevista': 'processing',
  Activa: 'default',
  Cancelada: 'error',
  'En Reclutamiento': 'warning',
  'Seleccionado(a)': 'success',
};

export default function CandidatosPorVacante({ vacante }) {
  const [form] = Form.useForm();
  const [formFiliacion] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [candidatos, setCandidatos] = useState([]);
  const [candidatosFicha, setCandidatosFicha] = useState([]);
  const [candidatoSeleccionadoId, setCandidatoSeleccionadoId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('');
  const [estadoscandidato, setEstadosCandidato] = useState([]);
  const [fuentesDeReclutamiento, setFuentesDeReclutamiento] = useState([]);
  const [candidatoSeleccionado, setCandidatoSeleccionado] = useState(null);
  const [fichaOpen, setFichaOpen] = useState(false);
  const [fichaempleadoOpen, setFichaEmpleadoOpen] = useState(false);
  const [generos, setGeneros] = useState([]);
  const [estadoCivil, setEstadoCivil] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [tiposSeguridadSocial, setTiposSeguridadSocial] = useState([]);
  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [vacanteInfo, setVacanteInfo] = useState(null);
  const [citasOpen, setCitasOpen] = useState(false);
  const [tiposDeIdentificaciones, setTiposDeIdentificaciones] = useState([]);
  const [tiposDeSeguridadesSociales, setTiposDeSeguridadesSociales] = useState([]);
  const [preferenciaPartidaria, setPreferenciaPartidaria] = useState([]);
  const [codigosPostales, setCodigosPostales] = useState([]);
  const [coloniasCargadas, setColoniasCargadas] = useState([]);
  const [currentParentTabKey, setCurrentParentTabKey] = useState('general');
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [isViewMode, setIsViewMode] = useState(false);
  const [nivelesDeEstudios, setNivelesDeEstudios] = useState([]);
  const [abreviaturasDeCarreras, setAbreviaturasDeCarreras] = useState([]);
  const [comprobantesDeEstudios, setComprobantesDeEstudios] = useState([]);
  const [especialidadesDeEstudios, setEspecialidadesDeEstudios] = useState([]);
  const [formDireccion] = Form.useForm();
  const [esEmpleadoMunicipio, setEsEmpleadoMunicipio] = useState(false);
  const [isEmpleadoDataLoaded, setIsEmpleadoDataLoaded] = useState(false);
  const [confirmDirectoOpen, setConfirmDirectoOpen] = useState(false);
  const [esReingreso, setEsReingreso] = useState(false);
  const [requiereModificar, setRequiereModificar] = useState(false);
  // Estados para CustomSearch
  const [openSearch, setVisibleSearch] = useState(false);
  const [dataSearch, setDataSearch] = useState([]);
  const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState(null);
  const [baseURIPagination, setBaseURIPagination] = useState('');
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const isFormBlocked = isViewMode || (isEmpleadoDataLoaded && !requiereModificar);
  const [visibleDelete, setVisibleDelete] = useState(false);

  const baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const fetchData = async () => {
    setLoading(true);
    const _candidatos = await getCandidatovistaOptimized();

    //  filtrar SOLO los de la vacante actual
    const candidatosFiltrados = _candidatos.filter(
      (c) => c.vacante_id === vacante.vacante_id,
    );

    // opcional: guardar info de la vacante si al menos hay un registro
    if (candidatosFiltrados.length > 0) {
      const infoVacante = candidatosFiltrados[0];
      setVacanteInfo(infoVacante);
    } else {
      setVacanteInfo(null);
    }

    setCandidatos(candidatosFiltrados);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();

      try {
        const [
          _estadoscandidato,
          _fuentesDeReclutamiento,
          _generos,
          _paises,
          _estados,
          _estadosCivil,
          _tiposSeguridadSocial,
          _nacionalidades,
          _candidatos,
          _tiposDeIdentificaciones,
          _tiposDeSeguridadesSociales,
          _preferenciaPartidaria,
          _nivelesDeEstudios,
          _abreviaturasDeCarreras,
          _comprobantesDeEstudios,
          _especialidadesDeEstudios,
        ] = await Promise.all([
          getEstadosCandidato(),
          getFuentesDeReclutamiento(),
          getGeneros(),
          getPaises(),
          getEstados(),
          getEstadosCiviles(),
          getTiposDeSeguridadSocial(),
          getNacionalidades(),
          getCandidatovistaOptimized(),
          getTiposDeIdentificaciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeSeguridadesSociales({ estados_globales: ESTATUS_AUTORIZADO }),
          getPreferenciaSPartidarias(),
          getNivelesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
          getAbreviaturasDeCarreras({ estados_globales: ESTATUS_AUTORIZADO }),
          getComprobantesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
          getEspecialidadesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),

        ]);
        if (mounted) {
          setPreferenciaPartidaria(_preferenciaPartidaria);
          setTiposDeSeguridadesSociales(_tiposDeSeguridadesSociales);
          setTiposDeIdentificaciones(_tiposDeIdentificaciones);
          setNivelesDeEstudios(_nivelesDeEstudios);
          setAbreviaturasDeCarreras(_abreviaturasDeCarreras);
          setComprobantesDeEstudios(_comprobantesDeEstudios);
          setEspecialidadesDeEstudios(_especialidadesDeEstudios);
          setGeneros(_generos);
          setPaises(_paises);
          setEstados(_estados);
          setEstadoCivil(_estadosCivil);
          setTiposSeguridadSocial(_tiposSeguridadSocial);
          setNacionalidades(_nacionalidades);
          setEstadosCandidato(_estadoscandidato);
          setFuentesDeReclutamiento(_fuentesDeReclutamiento);
          const candidatosFiltrados = _candidatos.filter(
            (c) => c.vacante_id === vacante.vacante_id,
          );
          // si hay al menos uno, usamos sus datos para la tarjeta
          if (candidatosFiltrados.length > 0) {
            const infoVacante = candidatosFiltrados[0];
            setVacanteInfo(infoVacante); // << estado nuevo
          }
          setCandidatos(candidatosFiltrados);
          setLoading(false);
        }
      } catch (err) {
        setLoading(false);
      }
    };

    fetchAll();
    return () => {
      mounted = false;
    };
  }, [vacante]);

  const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return null;
    const hoy = moment();
    const nacimiento = moment(fechaNacimiento);
    if (!nacimiento.isValid()) return null;
    return hoy.diff(nacimiento, 'years');
  };

  const normalizarCandidato = (data) => {
    if (!data) return {};

    return {
      ...data,
      id: data.id,
      numero_de_candidato: data.numero_de_candidato ?? null,
      nombre: data.nombre ?? '',
      apellido_paterno: data.apellido_paterno ?? '',
      apellido_materno: data.apellido_materno ?? '',

      curp: data.curp ?? data.CURP ?? '',
      RFC: data.RFC ?? '',

      correo_electronico: data.correo_electronico ?? '',
      numero_de_telefono: data.numero_de_telefono ?? '',
      numero_de_celular: data.numero_de_celular ?? '',

      fecha_de_nacimiento: data.fecha_de_nacimiento
        ? moment(data.fecha_de_nacimiento, 'YYYY-MM-DD')
        : null,

      genero: data.genero ?? null,
      estado_civil: data.estado_civil ?? null,
      nacionalidad: data.nacionalidad ?? null,
      pais: data.pais ?? null,

      //  resolver dependencias
      estado_nacimiento: data.estado_nacimiento ?? null,
      lugar_de_nacimiento: data.lugar_de_nacimiento ?? null,

      tiene_hijos: data.tiene_hijos ?? null,
      tipo_de_identificacion: data.tipo_de_identificacion ?? null,
      numero_de_identificacion: data.numero_de_identificacion ?? null,

      codigo_postal: data.codigo_postal ?? null,
      colonia: data.colonia ?? null,

      tipo_de_seguridad_social: data.tipo_de_seguridad_social ?? null,
      numero_de_seguridad_social: data.numero_de_seguridad_social ?? null,

      // estatus: si viene objeto o solo id
      estado_del_candidato: data.estado_del_candidato?.id ?? data.estado_del_candidato ?? null,

      // solicitud de contratación: id plano
      solicitud_de_contratacion: data.solicitud_de_contratacion?.id ?? data.solicitud_de_contratacion ?? null,

      fuente_de_reclutamiento: data.fuente_de_reclutamiento?.id ?? data.fuente_de_reclutamiento ?? null,

      referente: data.referente ?? null,

      nivel_de_estudios: data.nivel_de_estudios ?? null,
      abreviatura: data.abreviatura ?? null,
      comprobante: data.comprobante ?? null,
      estudios_concluidos: data.estudios_concluidos ?? false,
      numero_de_cedula_profesional: data.numero_de_cedula_profesional ?? null,
      especialidad_estudio: data.especialidad_estudio ?? null,

      es_empleado_del_municipio: data.es_empleado_del_municipio ?? false,
      es_reingreso: data.es_reingreso ?? false,
      requiere_modificar_datos: data.requiere_modificar_datos ?? false,
      fecha_de_alta: data.fecha_de_alta ? moment(data.fecha_de_alta, 'YYYY-MM-DD') : null,
      fecha_de_reingreso: data.fecha_de_reingreso ? moment(data.fecha_de_reingreso, 'YYYY-MM-DD') : null,
      numero_de_empleado: data.numero_de_empleado ?? null,
    };
  };

  const onCancel = () => {
    form.resetFields();
    formFiliacion.resetFields();
    setCandidatoSeleccionado(null);
    setCandidatoSeleccionadoId(null);
    setFichaOpen(false);
    setIsViewMode(false);
    setEsEmpleadoMunicipio(false);
    setEsReingreso(false);
    setRequiereModificar(false);
    setIsEmpleadoDataLoaded(false);
    setVisibleDelete(false);
  };
  // Nuevo candidato

  const onClickAdd = () => {
    onCancel();
    setCurrentParentTabKey('general');
    setCurrentTabKey('general');
    setFichaOpen(true);
    setCandidatoSeleccionado(null);
    setIsViewMode(false); //  importante
  };

  const onClickDelete = async () => {
    if (!candidatoSeleccionadoId) {
      message.warning('Selecciona un candidato para eliminar');
      return;
    }

    try {
      setLoading(true);
      await deleteCandidato(candidatoSeleccionadoId);
      message.success('Candidato eliminado');
      setCandidatoSeleccionadoId(null);
      await fetchData();
      onCancel();
      setLoading(false);
    } catch (err) {
      message.error('Error al eliminar el candidato');
      setLoading(false);
    }
  };
  const onClickEdit = async () => {
    if (!candidatoSeleccionadoId) {
      message.warning('Selecciona un candidato para editar');
      return;
    }

    try {
      setLoading(true);

      // 1. Obtener candidato desde API
      const candidatoApi = await getCandidato(candidatoSeleccionadoId);

      // 2. Normalizar
      const candidato = normalizarCandidato(candidatoApi);
      setEsEmpleadoMunicipio(candidato.es_empleado_del_municipio);
      setEsReingreso(candidato.es_reingreso);
      setRequiereModificar(candidato.requiere_modificar_datos);

      // 3. Reset forms antes de setear valores
      form.resetFields();
      formFiliacion.resetFields();

      // 4. Resolver dependencias
      if (candidato.lugar_de_nacimiento) {
        const _municipio = await getMunicipio(candidato.lugar_de_nacimiento);
        candidato.estado_nacimiento = _municipio?.estado?.id ?? null;
      }

      if (candidato.codigo_postal) {
        const cps = await getCodigosPostales({ id: candidato.codigo_postal });
        if (cps?.length) {
          const first = cps[0];
          formFiliacion.setFieldsValue({
            codigo_postal: candidato.codigo_postal,
            d_codigo: first.d_codigo,
            estado: first?.municipio?.estado?.nombre_de_AGEE || '',
            municipio: first?.municipio?.nom_mun || '',
          });
        }
      }

      // 5. Cargar en forms
      form.setFieldsValue(candidato);
      formFiliacion.setFieldsValue({
        RFC: candidato.RFC || null,
        curp: candidato.curp || null,
        tipo_de_identificacion: candidato.tipo_de_identificacion ?? null,
        numero_de_identificacion: candidato.numero_de_identificacion ?? null,
        referente: candidato.referente ?? null,
        fuente_de_reclutamiento: candidato.fuente_de_reclutamiento ?? null,
        tipo_de_seguridad_social: candidato.tipo_de_seguridad_social ?? null,
        numero_de_seguridad_social: candidato.numero_de_seguridad_social ?? null,
      });

      // Calcular edad a partir de la fecha de nacimiento
      if (candidato.fecha_de_nacimiento) {
        form.setFieldsValue({
          edad: calcularEdad(candidato.fecha_de_nacimiento),
        });
      }

      // if (candidato.pais) {
      //   const match = paises.find((p) => p.id === candidato.pais);
      //   if (match) {
      //     form.setFieldsValue({ pais: match.id }); // o match según cómo uses el Select
      //   }
      // }
      // 6. Guardar en estado global
      setCandidatoSeleccionado(candidato);

      // 7. Abrir ficha
      setFichaOpen(true);
      setLoading(false);
      setIsViewMode(false); // importante
    } catch (err) {
      onError(err);
      setLoading(false);
    }
  };

  // Campos requeridos de cada pestaña (Tabs de un solo nivel, key = currentParentTabKey).
  // Mismo patrón documentado en CLAUDE.md ("Formularios con pestañas") y ya usado en
  // Empleados.jsx/Becarios.jsx/HonorariosAsimilados.jsx: al fallar la validación, saltar
  // automáticamente a la pestaña donde vive el primer campo con error.
  const requiredFormStructure = [
    {
      tabKey: 'empleado',
      tabFields: ['es_empleado_del_municipio', 'es_reingreso', 'numero_de_empleado',
        'fecha_de_alta', 'fecha_de_reingreso'],
    },
    {
      tabKey: 'general',
      tabFields: ['nombre', 'apellido_paterno', 'genero', 'nacionalidad', 'pais',
        'estado_nacimiento', 'lugar_de_nacimiento', 'fecha_de_nacimiento', 'estado_civil',
        'tipo_sangre', 'estado_del_candidato'],
    },
    {
      tabKey: 'filiacion',
      tabFields: ['tipo_de_identificacion', 'numero_de_identificacion', 'RFC', 'd_codigo'],
    },
    {
      tabKey: 'contacto',
      tabFields: ['contacto_de_emergencia', 'correo_electronico'],
    },
  ];

  const onValidationError = (err) => {
    const errorKeys = (err?.errorFields || []).map((e) => e.name[0]);
    const tabWithError = requiredFormStructure.find(
      (entry) => entry.tabFields.some((campo) => errorKeys.includes(campo)),
    );
    if (tabWithError) {
      setCurrentParentTabKey(tabWithError.tabKey);
    }
    message.warning('Favor de corregir los errores señalados');
  };

  const onFinish = async (_values, continueEditing = false) => {
    try {
      setLoading(true);

      // Validar todos los formularios con catch de errores
      try {
        await form.validateFields();
        await formFiliacion.validateFields();
      } catch (validationError) {
        onValidationError(validationError);
        setLoading(false);
        return; // detenemos aquí para no armar el payload
      }

      // Unir todos los valores
      const values = {
        ...form.getFieldsValue(),
        ...formFiliacion.getFieldsValue(),
      };

      // Normalizar fecha
      if (moment.isMoment(values.fecha_de_nacimiento)) {
        values.fecha_de_nacimiento = values.fecha_de_nacimiento.format('YYYY-MM-DD');
      }

      if (moment.isMoment(values.fecha_de_reingreso)) {
        values.fecha_de_reingreso = values.fecha_de_reingreso.format('YYYY-MM-DD');
      }

      if (moment.isMoment(values.fecha_de_alta)) {
        values.fecha_de_alta = values.fecha_de_alta.format('YYYY-MM-DD');
      }

      // Convertir a enteros lo necesario
      if (values.estado_del_candidato) {
        values.estado_del_candidato = parseInt(values.estado_del_candidato, 10);
      }

      // Si no hay codigo_postal pero sí d_codigo, buscarlo
      if (!values.codigo_postal && values.d_codigo) {
        try {
          const codigos = await getCodigosPostales({ d_codigo: values.d_codigo });
          const match = codigos.find(
            (c) => c.d_codigo === values.d_codigo
              || String(c.d_codigo) === String(values.d_codigo),
          );
          if (match) {
            values.codigo_postal = match.id;
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('[Candidatos por Vacante] error al resolver código postal por d_codigo', e);
        }
      }

      // Agregar solicitud_de_contratacion
      if (vacante?.vacante_id) {
        values.solicitud_de_contratacion = vacante.vacante_id;
      }

      Object.keys(values).forEach((k) => {
        if (values[k] === undefined || values[k] === null || values[k] === '') {
          delete values[k];
        }
      });

      // Llamada a API (post o patch)
      let apiResponse;
      if (candidatoSeleccionadoId) {
        apiResponse = await patchCandidato(candidatoSeleccionadoId, values);
      } else {
        apiResponse = await postCandidato(values);
      }

      // 1. Detectar si el wrapper nos regresó el error (AxiosError) en lugar de hacer throw
      if (apiResponse instanceof Error || apiResponse?.isAxiosError || apiResponse?.name === 'AxiosError') {
        throw apiResponse; // Lo lanzamos para que el catch de abajo procese los errores del backend
      }

      // 2. Si no regresó nada, el wrapper tragó el error. Detenemos la ejecución.
      if (!apiResponse) {
        setLoading(false);
        return;
      }

      const data = apiResponse?.data ?? apiResponse;

      // 3. Detectar si la respuesta tiene forma de errores de validación (Status 200/201 con errores)
      const looksLikeValidationErrors = (obj) => {
        if (!obj || typeof obj !== 'object') return false;
        if (obj.id) return false; // Si trae ID es un guardado exitoso seguro
        return Object.values(obj).some(
          (v) => Array.isArray(v) && v.every((it) => typeof it === 'string'),
        );
      };

      // Si backend devolvió errores
      if (looksLikeValidationErrors(data)) {
        Object.entries(data).forEach(([campo, mensajes]) => {
          if (Array.isArray(mensajes)) {
            mensajes.forEach((m) => message.error(`${campo}: ${m}`));
          } else {
            message.error(`${campo}: ${mensajes}`);
          }
        });
        setLoading(false);
        return;
      }

      // Si todo salió bien y no hay errores, ahora sí mostramos el éxito
      if (candidatoSeleccionadoId) {
        message.success('Candidato actualizado');
      } else {
        message.success('Candidato agregado');
      }

      // Refrescar UI
      if (continueEditing) {
        await fetchData();
        const newId = data?.id ?? apiResponse?.id;
        if (newId) setCandidatoSeleccionadoId(newId);
        onClickEdit();
      } else {
        setFichaOpen(false);
        setVisible(false);
        await fetchData();
      }
    } catch (err) {
      if (err?.response?.data) {
        const errores = err.response.data;
        Object.entries(errores).forEach(([campo, mensajes]) => {
          // Protegemos con Array.isArray para evitar que la app explote si el backend regresa un string
          if (Array.isArray(mensajes)) {
            mensajes.forEach((m) => message.error(`${campo}: ${m}`));
          } else {
            message.error(`${campo}: ${mensajes}`);
          }
        });
      } else {
        onError(err, setLoading);
      }
    } finally {
      setLoading(false);
    }
  };

  const candidatosFiltrados = candidatos.filter((c) => {
    const nombre = c.nombre || c.candidato_numero_y_nombre_completo || '';
    return nombre.toLowerCase().includes(filtro.toLowerCase());
  });

  const getColor = (estatus) => {
    switch (estatus) {
      case 'ACTIVO(A)': return 'default';
      case 'CITADO(A)': return 'processing';
      case 'EVALUADO(A)':
      case 'ENTREVISTADO(A)': return 'warning';
      case 'SELECCIONADO(A)':
      case 'CONTRATADO(A)': return 'success';
      case 'NO SELECCIONADO(A)': return 'error';
      default: return 'default';
    }
  };

  const handleVerFicha = async (candidato) => {
    try {
      const candidatoApi = await getCandidato(candidato.id);
      const normalizado = normalizarCandidato(candidatoApi);

      setEsEmpleadoMunicipio(normalizado.es_empleado_del_municipio);
      setEsReingreso(normalizado.es_reingreso);
      setRequiereModificar(normalizado.requiere_modificar_datos);

      // resetear formularios
      form.resetFields();
      formFiliacion.resetFields();
      if (normalizado.lugar_de_nacimiento) {
        const _municipio = await getMunicipio(normalizado.lugar_de_nacimiento);
        normalizado.estado_nacimiento = _municipio?.estado?.id ?? null;
      }

      if (normalizado.codigo_postal) {
        const cps = await getCodigosPostales({ id: normalizado.codigo_postal });
        if (cps?.length) {
          const first = cps[0];
          formFiliacion.setFieldsValue({
            codigo_postal: normalizado.codigo_postal,
            d_codigo: first.d_codigo,
            estado: first?.municipio?.estado?.nombre_de_AGEE || '',
            municipio: first?.municipio?.nom_mun || '',
          });
        }
      }

      // setear todos los valores
      form.setFieldsValue(normalizado);
      formFiliacion.setFieldsValue(normalizado);

      // calcular edad
      if (normalizado.fecha_de_nacimiento) {
        form.setFieldsValue({
          edad: calcularEdad(normalizado.fecha_de_nacimiento),
        });
      }

      setCandidatoSeleccionado(normalizado);
      setIsViewMode(true);
      setFichaOpen(true);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('[Candidatos por Vacante] error al cargar el candidato para ver detalle', error);
    }
  };

  const handleBuscarEmpleado = async (numero) => {
    if (!numero) {
      form.resetFields();
      formFiliacion.resetFields();
      setIsEmpleadoDataLoaded(false);
      return;
    }

    setLoading(true);
    try {
      const empleados = await getEmpleados({ numero_de_empleado: numero });
      const empleado = empleados?.results?.[0];

      if (!empleado) {
        message.warning('No se encontró un empleado con ese número');
        form.resetFields();
        formFiliacion.resetFields();
        setIsEmpleadoDataLoaded(false);
        setLoading(false);
        return;
      }
      const datosEmpleado = {
        // Formulario 'form' (Generales / Contacto)
        ...empleado,
        nombre: empleado.nombre,
        apellido_paterno: empleado.apellido_paterno,
        apellido_materno: empleado.apellido_materno,
        fecha_de_nacimiento: empleado.fecha_de_nacimiento
          ? moment(empleado.fecha_de_nacimiento, 'YYYY-MM-DD')
          : null,
        genero: empleado.genero,
        estado_civil: empleado.estado_civil,
        nacionalidad: empleado.nacionalidad,
        pais: empleado.pais,
        lugar_de_nacimiento: empleado.lugar_de_nacimiento, // ID del municipio
        tiene_hijos: empleado.tiene_hijos,
        correo_electronico: empleado.correo_electronico,
        numero_de_telefono: empleado.numero_de_telefono,
        numero_de_celular: empleado.numero_de_celular,

        // Formulario 'formFiliacion'
        curp: empleado.curp || empleado.CURP,
        RFC: empleado.RFC,
        tipo_de_identificacion: empleado.tipo_de_identificacion,
        numero_de_identificacion: empleado.numero_de_identificacion,
        tipo_de_seguridad_social: empleado.tipo_de_seguridad_social,
        numero_de_seguridad_social: empleado.numero_de_seguridad_social,
        codigo_postal: empleado.codigo_postal, // ID del CP
      };

      // 1. Resolver Estado de Nacimiento
      if (datosEmpleado.lugar_de_nacimiento) {
        try {
          const _municipio = await getMunicipio(datosEmpleado.lugar_de_nacimiento);
          datosEmpleado.estado_nacimiento = _municipio?.estado?.id ?? null;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('[Candidatos por Vacante] error al resolver estado de nacimiento del empleado', e);
        }
      }

      // 2. Resolver Código Postal
      const cpId = empleado.codigo_postal;
      const cpTextoLibre = empleado.codigo_postal_fiscal_texto_libre;

      if (cpId) {
        // Opción A: Tiene el ID del catálogo directamente
        try {
          const cps = await getCodigosPostales({ id: cpId });
          if (cps?.length) {
            const first = cps[0];
            datosEmpleado.codigo_postal = first.id;
            datosEmpleado.d_codigo = first.d_codigo;
            datosEmpleado.estado = first?.municipio?.estado?.nombre_de_AGEE || '';
            datosEmpleado.municipio = first?.municipio?.nom_mun || '';
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('[Candidatos por Vacante] error al resolver código postal por id', e);
        }
      } else if (cpTextoLibre) {
        // Opción B: Tiene el CP como texto libre (ej. "45640")
        try {
          // Buscamos en el catálogo usando el texto
          const cps = await getCodigosPostales({ d_codigo: cpTextoLibre });
          if (cps?.length) {
            const first = cps[0];
            // Si lo encuentra, llenamos el estado y municipio automáticamente
            datosEmpleado.codigo_postal = first.id;
            datosEmpleado.d_codigo = first.d_codigo;
            datosEmpleado.estado = first?.municipio?.estado?.nombre_de_AGEE || '';
            datosEmpleado.municipio = first?.municipio?.nom_mun || '';
          } else {
            // Si el CP no existe en el catálogo, al menos lo escribimos en el input
            datosEmpleado.codigo_postal = cpTextoLibre;
            datosEmpleado.d_codigo = cpTextoLibre;
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('[Candidatos por Vacante] error al resolver código postal por texto libre', e);
        }
      }

      // 3. Calcular Edad
      if (datosEmpleado.fecha_de_nacimiento) {
        datosEmpleado.edad = calcularEdad(datosEmpleado.fecha_de_nacimiento);
      }

      // 4. Setear valores en AMBOS formularios
      form.setFieldsValue(datosEmpleado);
      formFiliacion.setFieldsValue(datosEmpleado);

      message.success(`Datos cargados para: ${empleado.nombre_completo || datosEmpleado.nombre}`);
      setIsEmpleadoDataLoaded(true);
    } catch (err) {
      message.error('Error al buscar los datos del empleado');
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const validadorSoloLetras = async (rule, value) => {
    const isValid = /^[a-zA-ZñÑáÁéÉíÍóÓúÚ]+(?: [a-zA-ZñÑáÁéÉíÍóÓúÚ]+)*$/.test(value);
    if (!isValid && value.length > 0) {
      throw new Error('Ingrese solo letras');
    }
  };

  const rules = {
    required: [requiredRule],
    lada: [requiredRule],
    numero_de_telefono: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese un número de empleado válido',
      },
    ],
    RFC: [
      requiredRule,
      {
        pattern: RFC_PATTERN,
        message: 'Ingrese un RFC válido',
      },
    ],
    curp: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value) {
            const validado = value.toUpperCase().match(CURP_PATTERN);
            if (!validado || validado[2] !== digitoVerificador(validado[1])) {
              throw new Error('Ingrese una CURP válida');
            }
          }
        },
      },
    ],
    fecha_de_nacimiento: [
      requiredRule,
      {
        validator: async (rule, value) => {
          const fechaFuturo = (Date.now() - value);
          const ageDate = new Date(fechaFuturo);
          const ageNum = (ageDate.getUTCFullYear() - 1970);
          if (fechaFuturo < 0) {
            throw new Error('Introduzca una fecha válida');
          } else if (ageNum < 16) {
            throw new Error('No se permiten empleados menores de 16 años');
          } else if (ageNum > 100) {
            throw new Error('No se permiten empleados mayores de 100 años');
          }
        },
      },
    ],
    solo_numeros_enteros: [
      {
        validator: async (rule, value) => {
          if (value) {
            const numeroEnteroBooleano = (/^\d+$/.test(value));
            const cantidadDeCaracteres = value.length;
            if ((!numeroEnteroBooleano) && (cantidadDeCaracteres > 0)) {
              throw new Error('Ingrese un número válido');
            }
          }
        },
      },
    ],
    sueldo_diario: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value) {
            const isValidNumber = /^\d+(\.\d{1,2})?$/.test(value);
            if (!isValidNumber) {
              throw new Error('Ingrese un número válido con máximo dos decimales');
            }
          }
        },
      },
    ],
    telefono: [
      {
        validator: async (rule, value) => {
          if (value) {
            const numeroEnteroBooleano = /^\d+$/.test(value);
            const cantidadDeCaracteres = value.length;
            if (!numeroEnteroBooleano || cantidadDeCaracteres !== 10) {
              throw new Error('Ingrese un número válido de 10 dígitos');
            }
          }
        },
      },
    ],
    no_identificacion: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value) {
            const numeroEnteroBooleano = /^\d+$/.test(value);
            const cantidadDeCaracteres = value.length;
            if (!numeroEnteroBooleano || cantidadDeCaracteres !== 11) {
              throw new Error('Ingrese un número válido de 11 dígitos');
            }
          }
        },
      },
    ],
    no_cedula_profesional: [
      {
        validator: async (rule, value) => {
          if (value) {
            const numeroEnteroBooleano = /^\d+$/.test(value);
            const cantidadDeCaracteres = value.length;
            if (!numeroEnteroBooleano || cantidadDeCaracteres > 10) {
              throw new Error('Ingrese un número válido menor a 10 dígitos');
            }
          }
        },
      },
    ],
    correo_electronico: [
      requiredRule,
      {
        type: 'email',
        message: 'Ingrese un correo válido',
      },
    ],
  };

  const onOpenConfirmDirecto = () => {
    if (!candidatoSeleccionadoId) {
      message.warning('Selecciona un candidato.');
      return;
    }
    setConfirmDirectoOpen(true);
  };

  const onFinishDirecto = async () => {
    try {
      setLoading(true);
      await putAutorizarContratacionDirecta(candidatoSeleccionadoId);

      message.success('Contratación directa autorizada correctamente');

      setConfirmDirectoOpen(false);
      fetchData();
      setCandidatoSeleccionadoId(null);
    } catch (err) {
      const msg = err.response?.data?.message || 'Error al autorizar contratación directa';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const onChangeEmpleado = async (val) => {
    if (val) {
      try {
        setLoading(true);

        // 1. Obtener datos base del empleado
        const _empleado = await getEmpleado(val);

        // 2. Obtener datos operacionales (Plaza/Puesto)
        const datosOpResponse = await getDatoOperacionalesDeEmpleados({ empleado: val });
        const _datosOperacionales = Array.isArray(datosOpResponse) ? datosOpResponse[0] : datosOpResponse;

        let _plaza = null;
        if (_datosOperacionales?.plaza) {
          try {
            _plaza = await getPlaza(_datosOperacionales.plaza);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error('[Candidatos por Vacante] error al cargar la plaza del empleado', e);
          }
        }

        // 3. Preparar textos visuales
        const nombreCompleto = _empleado?.numero_y_nombre_completo
          ? _empleado.numero_y_nombre_completo
          : `${_empleado?.numero_de_empleado || ''} - ${_empleado?.nombre || ''} ${_empleado?.apellido_paterno || ''} ${_empleado?.apellido_materno || ''}`;

        // 4. Sincronizar Formulario Principal (General/Contacto)
        form.setFieldsValue({
          ..._empleado,
          numero_de_empleado: _empleado?.numero_de_empleado,
          nombre: _empleado.nombre,
          apellido_paterno: _empleado.apellido_paterno,
          apellido_materno: _empleado.apellido_materno,
          fecha_de_nacimiento: _empleado.fecha_de_nacimiento ? moment(_empleado.fecha_de_nacimiento, 'YYYY-MM-DD') : null,
          genero: _empleado.genero,
          estado_civil: _empleado.estado_civil,
          nacionalidad: _empleado.nacionalidad,
          pais: _empleado.pais,
          lugar_de_nacimiento: _empleado.lugar_de_nacimiento,
          tiene_hijos: _empleado.tiene_hijos,
          correo_electronico: _empleado.correo_electronico,
          numero_de_telefono: _empleado.numero_de_telefono,
          numero_de_celular: _empleado.numero_de_celular,
          edad: _empleado.fecha_de_nacimiento ? calcularEdad(_empleado.fecha_de_nacimiento) : null,
        });

        // 5. Sincronizar Formulario de Filiación
        formFiliacion.setFieldsValue({
          curp: _empleado.curp || _empleado.CURP,
          RFC: _empleado.RFC,
          tipo_de_identificacion: _empleado.tipo_de_identificacion,
          numero_de_identificacion: _empleado.numero_de_identificacion,
          tipo_de_seguridad_social: _empleado.tipo_de_seguridad_social,
          numero_de_seguridad_social: _empleado.numero_de_seguridad_social,
        });

        // 6. Resolver Código Postal si existe
        if (_empleado.codigo_postal) {
          const cps = await getCodigosPostales({ id: _empleado.codigo_postal });
          if (cps?.length) {
            const first = cps[0];
            formFiliacion.setFieldsValue({
              codigo_postal: _empleado.codigo_postal,
              d_codigo: first.d_codigo,
              estado: first?.municipio?.estado?.nombre_de_AGEE || '',
              municipio: first?.municipio?.nom_mun || '',
            });
          }
        }

        setSelectedEmpleadoSearch(_empleado);
        setIsEmpleadoDataLoaded(true);
        message.success(`Datos cargados para: ${nombreCompleto}`);
      } catch (error) {
        message.error('Error al cargar datos del empleado');
      } finally {
        setLoading(false);
      }
    } else {
      form.resetFields(['numero_de_empleado', 'nombre', 'apellido_paterno', 'apellido_materno']);
      setSelectedEmpleadoSearch(null);
      setIsEmpleadoDataLoaded(false);
    }
  };

  // Lógica de búsqueda para el CustomSearch
  const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
    setLoading(true);
    let query = baseURIDatosOpPaginado;

    if (empId) query += `numero_de_empleado=${empId};`;
    if (nombreEmp) query += `nombre=${nombreEmp};`;
    if (apPatEmp) query += `apellido_paterno=${apPatEmp};`;
    if (apMatEmp) query += `apellido_materno=${apMatEmp};`;
    // if (tipoNominaEmpleado) query += `&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`; // Descomentar si usas este filtro

    setBaseURIPagination(query);
    try {
      const _empleados = await getEmpleadosConDatosOpFilteredPaginated(query);
      setDataSearch(_empleados);
    } catch (error) {
      message.error('Error al buscar empleados');
    } finally {
      setLoading(false);
    }
  };
  const ModalForDelete = () => (
    <ModalConfirmation
      onFinish={onClickDelete}
      ConfirmAutorize
      onCancel={() => setVisibleDelete(false)}
      open={visibleDelete}
      contentTitle="Eliminar al Candidato"
      loading={loading}
    />
  );
  // Columnas para la tabla del modal
  const columnsEmpleado = [
    {
      titleText: 'No. Empleado',
      dataIndex: 'empleado',
      key: 'empleado_num',
      width: 150,
      render: (obj) => obj?.numero_de_empleado,
    },
    {
      titleText: 'Nombre Completo',
      dataIndex: 'empleado',
      key: 'empleado_nombre',
      width: 300,
      render: (obj) => `${obj?.nombre || ''} ${obj?.apellido_paterno || ''} ${obj?.apellido_materno || ''}`,
    },
    {
      titleText: 'RFC',
      dataIndex: 'empleado',
      key: 'rfc',
      width: 150,
      render: (obj) => obj?.RFC,
    },
    {
      titleText: 'CURP',
      dataIndex: 'empleado',
      key: 'curp',
      width: 180,
      render: (obj) => obj?.curp || obj?.CURP,
    },
  ];

  return (
    <div>
      <Title level={3}>
        Candidatos para:
        {' '}
        {vacante.vacantePlaza}
      </Title>

      <Collapse>
        <Panel header="Información de la Vacante" key="1">
          <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col xs={24} md={12}>
              <Card>
                <Title level={4} style={{ marginBottom: 0 }}>Vacante</Title>
                <Text type="secondary">
                  {vacanteInfo?.vacante__folio || '—'}
                  {' '}
                  /
                  {vacanteInfo?.vacante_fecha_de_solicitud || '—'}
                </Text>

                <Row gutter={[12, 12]} style={{ marginTop: 16 }}>
                  <Col span={12}>
                    <Text type="secondary">Área</Text>
                    <br />
                    <Text>{vacanteInfo?.vacante_directorio_de_area_clave_y_nombre || '—'}</Text>
                  </Col>
                  <Col span={12}>
                    <Text type="secondary">Puesto</Text>
                    <br />
                    <Text>{vacanteInfo?.vacante_puesto_clave_y_descripcion || '—'}</Text>
                  </Col>
                  <Col span={12}>
                    <Text type="secondary">Plaza</Text>
                    <br />
                    <Text>{vacanteInfo?.vacante_plaza_clave_y_descripcion || '—'}</Text>
                  </Col>

                  <Col span={12}>
                    <Text type="secondary">Tipo de Empleado</Text>
                    <br />
                    <Text>{vacante.empleadoTipo}</Text>
                  </Col>
                  <Col span={12}>
                    <Text type="secondary">Motivo</Text>
                    <br />
                    <Text>{vacante.vacanteMotivo}</Text>
                  </Col>
                  <Col span={12}>
                    <Text type="secondary">Estatus</Text>
                    <br />
                    <Text>{vacanteInfo?.vacante_estado_global_descripcion || '—'}</Text>
                  </Col>
                  <Col span={24}>
                    <Text type="secondary">Pruebas Asignadas</Text>
                    <br />
                    <Space wrap>
                      {vacante.pruebasAsignadas && vacante.pruebasAsignadas.length > 0 && (
                        vacante.pruebasAsignadas.map((p) => (
                          <Tag key={p}>{p}</Tag>
                        ))
                      )}

                      {(!vacante.pruebasAsignadas || vacante.pruebasAsignadas.length === 0) && vacanteInfo?.candidato_pruebas_y_otros && (
                        vacanteInfo.candidato_pruebas_y_otros
                          .split(',')
                          .map((p) => {
                            const prueba = p.trim();
                            return <Tag key={prueba}>{prueba}</Tag>;
                          })
                      )}

                      {(!vacante.pruebasAsignadas || vacante.pruebasAsignadas.length === 0)
                        && !vacanteInfo?.candidato_pruebas_y_otros && (
                          <Text>Sin pruebas</Text>)}
                    </Space>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col xs={24} md={12}>
              <Card>
                <Title level={4} style={{ marginBottom: 0 }}>Solicitante</Title>
                <Text type="secondary">{vacanteInfo?.solicitante || '—'}</Text>

                <Row gutter={[12, 12]} style={{ marginTop: 16 }}>
                  <Col span={24}>
                    <Text type="secondary">Área</Text>
                    <br />
                    <Text>{vacanteInfo?.solicitante_directorio_de_area_clave_y_nombre || '—'}</Text>
                  </Col>
                  <Col span={12}>
                    <Text type="secondary">Puesto</Text>
                    <br />
                    <Text>{vacanteInfo?.solicitante_puesto_clave_y_descripcion || '—'}</Text>
                  </Col>
                  <Col span={12}>
                    <Text type="secondary">Plaza</Text>
                    <br />
                    <Text>{vacanteInfo?.solicitante_plaza_clave_y_descripcion || '—'}</Text>
                  </Col>

                </Row>
              </Card>
            </Col>
          </Row>
        </Panel>
      </Collapse>

      <Space style={{ marginTop: 24 }}>
        <Input
          placeholder="Buscar candidato..."
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          style={{ width: 300 }}
        />
        <Button onClick={onClickAdd}>Agregar</Button>
        <Button onClick={onClickEdit} disabled={!candidatoSeleccionadoId}>Editar</Button>
        <Button onClick={() => { setVisibleDelete(true); }} disabled={!candidatoSeleccionadoId}>Eliminar</Button>
        <Button
          onClick={onOpenConfirmDirecto}
          disabled={!candidatoSeleccionadoId}
        >
          Directo
        </Button>
      </Space>

      {/* Lista de candidatos o spinner */}
      {loading ? (
        <Spin />
      ) : (
        <div>
          {candidatosFiltrados.length === 0 ? (
            <Text type="secondary">No hay candidatos disponibles.</Text>
          ) : (
            candidatosFiltrados.map((candidato) => (
              <div key={candidato.id}>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '7fr 2fr', // izquierda más ancha que la derecha
                    gap: 16,
                    alignItems: 'center',
                    width: '100%',
                    border: '1px solid #f0f0f0',
                    padding: 20,
                    borderRadius: 6,
                  }}
                >
                  {/* Columna izquierda: Nombre + Botones */}
                  <div>
                    {/* Nombre */}
                    <Text strong style={{ fontSize: 15 }}>
                      {candidato.candidato_numero_y_nombre_completo || '—'}
                    </Text>

                    {/* Botones debajo del nombre */}
                    <div
                      style={{
                        marginTop: 12,
                        display: 'flex',
                        gap: 24,
                        flexWrap: 'wrap',
                      }}
                    >
                      {/* Botón Ver Ficha */}
                      <Button
                        style={{ width: '30%' }}
                        size="large"
                        icon={<FileSearchOutlined />}
                        onClick={() => handleVerFicha(candidato)}
                      >
                        Ver Ficha
                      </Button>

                      {/* Botón Cita */}
                      <Button
                        style={{ width: '30%' }}
                        size="large"
                        icon={<CalendarOutlined />}
                        onClick={() => {
                          setCandidatoSeleccionado(candidato);
                          setCitasOpen(true);
                        }}
                      >
                        Cita
                      </Button>
                    </div>
                  </div>

                  {/* Columna derecha: Estatus + Check */}
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 12 }}
                  >
                    <Tag
                      color={getColor(
                        candidato.candidato_estado_del_candidato_descripcion,
                      )}
                      style={{ fontSize: 14, padding: '6px 12px' }}
                    >
                      {candidato.candidato_estado_del_candidato_descripcion
                        || '—'}
                    </Tag>

                    {/* Botón seleccionar */}
                    <Button
                      size="large"
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 6,
                        border:
                          candidatoSeleccionadoId === candidato.id
                            ? '2px solid #1890ff'
                            : '1px solid #d9d9d9',
                        background:
                          candidatoSeleccionadoId === candidato.id
                            ? '#1890ff'
                            : '#fff',
                        color:
                          candidatoSeleccionadoId === candidato.id
                            ? '#fff'
                            : '#1890ff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 18,
                        transition: 'all 0.2s',
                        boxShadow:
                          candidatoSeleccionadoId === candidato.id
                            ? '0 0 0 2px #91d5ff'
                            : undefined,
                        cursor: 'pointer',
                      }}
                      onClick={() => setCandidatoSeleccionadoId(
                        candidatoSeleccionadoId === candidato.id
                          ? null
                          : candidato.id,
                      )}
                      icon={
                        candidatoSeleccionadoId === candidato.id ? (
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <polyline
                              points="4,9 8,13 14,5"
                              stroke="#fff"
                              strokeWidth="2.2"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        ) : (
                          <div />
                        )
                      }
                      aria-label={
                        candidatoSeleccionadoId === candidato.id
                          ? 'Deseleccionar candidato'
                          : 'Seleccionar candidato'
                      }
                    />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {/* Modal de ficha */}
      {/* USAR EL QUE SE ENCUENTRA EN EMPLEADOS */}
      <Modal
        open={fichaOpen}
        closable={false} // si es ficha, no mostrar botón cerrar arriba
        maskClosable={!loading}
        keyboard={!loading}
        footer={null}
        forceRender
        width={1000}
        title={
          !isViewMode ? (
            <FormSubmitControls
              label={candidatoSeleccionado ? 'Editar Candidato' : 'Nuevo Candidato'}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave
            />
          ) : (
            <FormSubmitControls
              label="Ficha del Candidato"
              onCancel={onCancel}
              loading={false}
              allowSave={false} //  no mostrar botón guardar
            />
          )
        }
        onCancel={onCancel}
      >
        <Form
          layout="vertical"
          form={form}
          initialValues={candidatoSeleccionado ?? {}}
          onFinish={onFinish}
        >

          <Tabs
            defaultActiveKey="empleado"
            activeKey={currentParentTabKey}
            onChange={setCurrentParentTabKey}
          >

            <TabPane
              tab={(
                <span>
                  <SearchOutlined />
                  {' '}
                  Previo
                </span>
              )}
              key="empleado"
              forceRender
            >
              <Form
                layout="vertical"
                form={form} // Usamos el mismo form instance
                name="buscar_empleado"
              >
                <Row gutter={[24, 12]}>
                  {/* Contiene: ¿Es Empleado?, Buscador y Fecha de Alta */}
                  <Col xs={24} md={12}>

                    {/* 1. ¿Es Empleado Actual? */}
                    <Form.Item
                      name="es_empleado_del_municipio"
                      label="¿Es empleado actual del Municipio de Tlajomulco?"
                      initialValue={false}
                      rules={[{ required: true, message: 'Selecciona una opción' }]}
                      hasFeedback
                    >
                      <Select
                        trueFalse
                        disabled={isViewMode || esReingreso} // Se bloquea si ya seleccionaste Reingreso
                        onChange={(value) => {
                          setEsEmpleadoMunicipio(value);
                          if (!value) {
                            // Si cambia a NO...
                            if (!esReingreso) {
                              // Y no es reingreso, limpiamos todo y la búsqueda
                              form.resetFields();
                              formFiliacion.resetFields();
                              setIsEmpleadoDataLoaded(false);
                              // Restauramos los valores de los selectores para que no queden null
                              form.setFieldsValue({
                                es_empleado_del_municipio: false,
                                es_reingreso: false,
                              });
                            }
                          }
                        }}
                      />
                    </Form.Item>

                    {/* 2. Buscador de Empleado */}
                    {/* Visible si es Empleado Actual O es Reingreso */}
                    <Form.Item
                      label="Número de Empleado"
                      required={esEmpleadoMunicipio || esReingreso}
                      shouldUpdate
                    >
                      {() => (
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <Form.Item
                            name="numero_de_empleado"
                            noStyle
                            rules={
                              (esEmpleadoMunicipio || esReingreso)
                                ? [{ required: true, message: 'Captura el número de empleado' }]
                                : []
                            }
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              min={1}
                              disabled={isViewMode || (!esEmpleadoMunicipio && !esReingreso)}
                              // Si da Enter, intenta buscar directo por número
                              onPressEnter={(e) => {
                                const val = e.target.value;
                                if (val) handleBuscarEmpleado(val);
                              }}
                            />
                          </Form.Item>

                          {/* Botón que abre el Modal de Búsqueda Avanzada */}
                          <Button
                            icon={<SearchOutlined />}
                            disabled={isViewMode || (!esEmpleadoMunicipio && !esReingreso)}
                            onClick={() => {
                              // Si el input tiene valor, buscamos ese directo.
                              // Si está vacío, abrimos el modal avanzado.
                              const numero = form.getFieldValue('numero_de_empleado');
                              if (numero) {
                                handleBuscarEmpleado(numero);
                              } else {
                                setVisibleSearch(true); // <--- Abre el modal
                              }
                            }}
                          >
                            Buscar
                          </Button>
                        </div>
                      )}
                    </Form.Item>

                    {/* 3. Fecha de Alta */}
                    {/* Visible solo si NO es empleado Y NO es reingreso (Nuevo Ingreso puro) */}
                    {!esEmpleadoMunicipio && !esReingreso && (
                      <Form.Item
                        name="fecha_de_alta"
                        label="Fecha de Alta"
                        rules={[{ required: true, message: 'La fecha de alta es obligatoria' }]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD/MM/YYYY"
                          disabled={isViewMode}
                        />
                      </Form.Item>
                    )}
                  </Col>
                  {/* Contiene: ¿Es Reingreso?, ¿Modificar? y Fecha Reingreso */}
                  <Col xs={24} md={12}>

                    {/* 4. ¿Es Reingreso? */}
                    <Form.Item
                      name="es_reingreso"
                      label="¿Es Reingreso de Empleado?"
                      initialValue={false}
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <Select
                        trueFalse
                        disabled={isViewMode || esEmpleadoMunicipio} // Se bloquea si ya es Empleado Actual
                        onChange={(val) => {
                          setEsReingreso(val);
                          if (!val) {
                            // Si desmarca, apagamos la bandera de modificar y limpiamos datos si no es empleado actual
                            setRequiereModificar(false);
                            form.setFieldsValue({ requiere_modificar_datos: false });
                            if (!esEmpleadoMunicipio) {
                              setIsEmpleadoDataLoaded(false);
                              form.resetFields(['numero_de_empleado']);
                            }
                          }
                        }}
                      />
                    </Form.Item>

                    {/* 5. ¿Requiere Modificar Datos? */}
                    {/* Solo visible si es Reingreso */}
                    <Form.Item
                      name="requiere_modificar_datos"
                      label="¿Requiere Modificar Datos del Empleado?"
                      initialValue={false}
                    >
                      <Select
                        trueFalse
                        disabled={!esReingreso || isViewMode}
                        onChange={(val) => setRequiereModificar(val)}
                      />
                    </Form.Item>

                    {/* 6. Fecha de Reingreso */}
                    {/* Solo visible si es Reingreso */}
                    {esReingreso && (
                      <Form.Item
                        name="fecha_de_reingreso"
                        label="Fecha de Reingreso"
                        rules={[{ required: true, message: 'La fecha de reingreso es obligatoria' }]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD/MM/YYYY"
                          disabled={isViewMode}
                        />
                      </Form.Item>
                    )}
                  </Col>

                </Row>
              </Form>
            </TabPane>
            <TabPane
              tab={(
                <span>
                  <UserOutlined />
                  {' '}
                  General
                </span>
              )}
              key="general"
              forceRender
            >
              <CandidatoGeneral
                form={form}
                formFiliacion={formFiliacion}
                rules={rules}
                selectedRowKeys={candidatoSeleccionado}
                generos={generos}
                estados={estados}
                estadoCivil={estadoCivil}
                nacionalidades={nacionalidades}
                paises={paises}
                calcularEdad={calcularEdad}
                estadosCandidato={estadoscandidato}
                isBlocked={isFormBlocked}
              />
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <FileTextOutlined />
                  {' '}
                  Filiación
                </span>
              )}
              key="filiacion"
              forceRender
            >
              <CandidatoFiliacion
                form={form}
                formFiliacion={formFiliacion}
                tiposDeIdentificaciones={tiposDeIdentificaciones}
                tiposDeSeguridadesSociales={tiposDeSeguridadesSociales}
                fuentesDeReclutamiento={fuentesDeReclutamiento}
                rules={rules}
                preferenciaPartidaria={preferenciaPartidaria}
                codigosPostales={codigosPostales}
                coloniasCargadas={coloniasCargadas}
                isBlocked={isFormBlocked}
              />
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <PhoneOutlined />
                  {' '}
                  Contacto
                </span>
              )}
              key="contacto"
              forceRender
            >
              <CandidatoContacto
                form={form}
                rules={rules}
                isBlocked={isViewMode || isEmpleadoDataLoaded}
              />
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <EnvironmentOutlined />
                  {' '}
                  {' '}
                  Dirección
                </span>
              )}
              key="direccion"
              forceRender
              disabled={!candidatoSeleccionado?.id}
            >
              <DireccionesCandidato
                formDireccion={formDireccion}
                rules={rules}
                coloniasCargadas={coloniasCargadas}
                paises={paises}
                // isBlocked={isBlocked}
                // permission={permission}
                candidatoId={candidatoSeleccionado?.id}
              />
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <FileTextOutlined />
                  {' '}
                  {' '}
                  Estudios
                </span>
              )}
              key="estudios"
              forceRender
            >
              <CandidatosEstudios
                form={form}
                rules={rules}
                nivelesDeEstudios={nivelesDeEstudios}
                abreviaturasDeCarreras={abreviaturasDeCarreras}
                comprobantesDeEstudios={comprobantesDeEstudios}
                especialidadesDeEstudios={especialidadesDeEstudios}
                isBlocked={isViewMode || isEmpleadoDataLoaded}
              />
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <SolutionOutlined />
                  {' '}
                  {' '}
                  Documentos
                </span>
              )}
              key="documentos"
              forceRender
              disabled={!candidatoSeleccionado?.id}
            >
              <DocumentosCandidato
                // permission={getPermission}
                candidatoId={candidatoSeleccionado?.id} //  cambia a candidatoId si lo manejas así
                formEmpleado={form}
                rules={rules}
              />
            </TabPane>

          </Tabs>
        </Form>
      </Modal>

      <Modal
        open={confirmDirectoOpen}
        closable={false}
        maskClosable={!loading}
        keyboard={!loading}
        footer={null}
        title={(
          <FormSubmitControls
            label="Confirmar Contratación Directa"
            onFinish={onFinishDirecto}
            onCancel={() => setConfirmDirectoOpen(false)}
            loading={loading}
            allowSave
          />
        )}
        onCancel={() => setConfirmDirectoOpen(false)}
        forceRender
      >
        <p style={{ fontSize: 16, marginTop: 10 }}>
          ¿Deseas autorizar la contratación directa del candidato
          {' '}
          <strong>
            {candidatos.find((c) => c.id === candidatoSeleccionadoId)
              ?.candidato_numero_y_nombre_completo}
          </strong>
          ?
        </p>
      </Modal>

      <Modal
        open={citasOpen}
        onCancel={() => setCitasOpen(false)}
        footer={null}
        width="90%"
        style={{ top: 20 }}
        destroyOnClose
      >
        <CitasCalendario candidato={candidatoSeleccionado} />
      </Modal>
      <ModalForDelete />

      <CustomSearch
        form={form}
        open={openSearch}
        setVisible={setVisibleSearch}
        modalTitle="Buscar Empleado"
        firstInputLabel="No. de Empleado"
        firstInputName="numero_de_empleado"
        secondInputLabel="Nombre del Empleado"
        secondInputName="nombre"
        searchInputLabel="Apellido Paterno"
        searchInputName="apellido_paterno"
        thirdInputLabel="Apellido Materno"
        thirdInputName="apellido_materno"
        firstSelectLabel="Tipo de Nómina Empleado"
        firstSelectName="tipo_de_nomina_empleado"
        firstSelectDataSource={tiposDeNominaEmpleado}
        inputsNeeded={3}
        selectsNeeded={1}
        paginatedTable
        modalWidth={1400}
        columns={columnsEmpleado}
        baseURI={baseURIPagination}
        setSelectedRow={setSelectedEmpleadoSearch}
        onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
        data={dataSearch}
        setData={setDataSearch}
        searchData={searchData}
        onChange={(row) => {
          // Extraemos el valor crudo
          const numeroRaw = typeof row === 'object'
            ? (row?.empleado?.numero_de_empleado || row?.numero_de_empleado || row?.id)
            : row;

          // CONVERSIÓN CLAVE: Transformamos el string "9" a número 9
          const numero = Number(numeroRaw);

          if (numero) {
            // 1. Asignamos el valor numérico al form
            form.setFieldsValue({ numero_de_empleado: numero });

            // 2. Ejecutamos la búsqueda
            handleBuscarEmpleado(numero);

            // 3. Cerramos el modal
            setVisibleSearch(false);
          } else {
            message.error('No se pudo obtener el número del empleado.');
          }
        }}
      />

      {fichaempleadoOpen && candidatoSeleccionado && (
        <FichaCandidatos
          open={fichaempleadoOpen}
          onClose={() => setFichaEmpleadoOpen(false)}
          candidato={candidatoSeleccionado}
          vacante={vacante}
        />
      )}
    </div>

  );
}
